export default __webpack_public_path__ + "f1dc10a756c2c544588b7408095ffed7.woff2";